import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const window = require('global/window');

export function useResizeWidth() {
  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    function onChange(event: UIEvent) {
      const target = event.target as Window;
      if (target) {
        setWidth(target.innerWidth);
      }
    }
    window.addEventListener('resize', onChange);
    return () => window.removeEventListener('resize', onChange);
  }, []);
  return width;
}
